import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AutheticationService } from './authetication.service';
import { Observable } from 'rxjs/Observable';
import { Client } from './client';
import { catchError, map } from 'rxjs/operators';
import { SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ServiceConfService {
  translate: any;
  isEnumString = 'in:[A-Za-z_]*(,|$)';
  isSliderString = 'min:([0-9]*)[/|]{1}max:([0-9]*)$';
  enumRexExp: RegExp;
  sliderRexExp: RegExp;
  private settingsUrl = this.client.getSettingsUrl();
  private notificationsSettingsUrl = this.client.getNotificationsSettingsUrl();
  private reasonsUrl = this.client.getTripCloseReasons();

  constructor(
    translate: TranslateService,
    private http: HttpClient,
    private auth: AutheticationService,
    private client: Client
  ) {
    this.translate = translate;
    this.enumRexExp = new RegExp(this.isEnumString, 'i');
    this.sliderRexExp = new RegExp(this.isSliderString, 'i');
  }

  getPassengersApps() {
    return this.http.get('operator/passenger-apps');
  }

  getAppsNotificationSettings(id) {
    return this.http.get('operator/passenger-app/settings/notification-gates?id=' + id);
  }

  putAppsNotificationSettings(body) {
    return this.http.put('operator/passenger-app/settings/notification-gates', body);
  }

  getNotificationsGates(service_id): Observable<any> {
    return this.http.get(this.settingsUrl + '/gates?service=' + service_id);
  }

  putNotificationsGates(service_id, obj): Observable<any> {
    return this.http.put(this.settingsUrl + '/gate?service_id=' + service_id, obj);
  }

  getNotificationsSettings(service_id): Observable<any> {
    return this.http.get(this.notificationsSettingsUrl + '?service=' + service_id);
  }

  putNotificationsSettings(service_id, obj): Observable<any> {
    return this.http.put(this.notificationsSettingsUrl + '?service_id=' + service_id, obj);
  }

  resetNotificationsSettings(service_id, notifyFormat): Observable<any> {
    return this.http.get(this.notificationsSettingsUrl + '/reset?service_id=' + service_id + '&key=' + notifyFormat);
  }

  getTaxiserviceSettings(service_id, search_string): Observable<any> {
    let token = this.auth.getLocalStorage('token');
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json'
    });

    return this.http
      .get(this.settingsUrl + '?service=' + service_id, {
        headers: headers
      })
      .pipe(
        map((res: any) => {
          let arrToMap = res['data'];
          let searchedArr = [];
          if (search_string.length > 2) {
            res['data'].forEach((setting, index) => {
              let inCurrentLang = this.translate.get(setting['key']).value;
              let re = new RegExp(search_string, 'i');
              if (inCurrentLang.search(re) >= 0) {
                searchedArr.push(setting);
              }
            });
            arrToMap = searchedArr;
          }

          let treeStringsGroup = new Map();
          arrToMap.forEach(setting => {
            let settingsValueAsKey = setting['group'];
            const collection = treeStringsGroup.get(settingsValueAsKey);
            if (!collection) {
              treeStringsGroup.set(settingsValueAsKey, [setting]);
            } else {
              collection.push(setting);
            }
          });

          let resultArr = [];
          treeStringsGroup.forEach((item, key) => {
            let groupLevel = new Map();
            groupLevel['label'] = key;
            groupLevel['data'] = key;
            groupLevel['expandedIcon'] = 'fa fa-folder-open';
            groupLevel['collapsedIcon'] = 'fa fa-folder';
            groupLevel['children'] = [];
            groupLevel['selectable'] = false;

            item.forEach(setting => {
              let childMap = new Map();
              childMap['label'] = setting['key'];
              childMap['icon'] = 'fa fa-file-word-o';
              let selectData: SelectItem[] = [];
              let sliderData = [];
              let checkEnum = setting['rules'].search(this.enumRexExp);
              let checkSlider = setting['rules'].search(this.sliderRexExp);
              if (setting['rules'] == 'required|boolean') {
                setting['value'] = setting['value'] == '0' ? false : true;
              } else if (checkEnum > 0) {
                let splitString = setting['rules'].substr(checkEnum + 3);
                let selectArr = splitString.split(',');
                selectData = selectArr.map(function(selectValue) {
                  return { label: selectValue, value: selectValue };
                });
              }

              childMap['data'] = {
                value: setting['value'],
                rules: setting['rules'],
                default: setting['default'],
                selectBoxData: selectData,
                sliderData: sliderData
              };
              groupLevel['children'].push(childMap);
            });
            resultArr.push(groupLevel);
          });
          return resultArr;
        }),
        catchError((error: any) => Observable.throw(error.code || error.error || 'UNDEF error'))
      );
  }

  updateTaxiserviceSettings(service_id, key, config_value): Observable<any> {
    let token = this.auth.getLocalStorage('token');
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
      'X-Taxi-Service': service_id
    });
    const postData = {
      key: key,
      value: config_value,
      service: service_id
    };

    return this.http
      .put(this.settingsUrl, JSON.stringify(postData), {
        headers: headers
      })
      .pipe(
        map(res => {
          return res;
        }),
        catchError((error: any) => Observable.throw(error.code || error.error || 'UNDEF error'))
      );
  }

  getReasons(service_id): Observable<any> {
    let token = this.auth.getLocalStorage('token');
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json'
    });

    return this.http.get(this.reasonsUrl + '?service=' + service_id, {
      headers: headers
    });
  }

  storeReason(tripCloseReason, service_id): Observable<any> {
    let token = this.auth.getLocalStorage('token');
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
      'X-Taxi-Service': service_id
    });
    let penalty = null;
    if (tripCloseReason.penalty_value != 0 && tripCloseReason.penalty_value != '0%') {
      if (tripCloseReason.penalty_value.indexOf('+') == 0) {
        penalty = tripCloseReason.penalty_value;
      } else {
        penalty = '+' + tripCloseReason.penalty_value;
      }
    }
    const postData = {
      display_name: tripCloseReason.display_name,
      loc_display_name: tripCloseReason.loc_display_name,
      penalty_value: penalty,
      should_penalty: this.cleanNumber(tripCloseReason.penalty_value) ? 1 : 0
    };

    return this.http.post(this.reasonsUrl + '?service_id=' + service_id, JSON.stringify(postData), {
      headers: headers
    });
  }

  updateReason(tripCloseReason, service_id): Observable<any> {
    let token = this.auth.getLocalStorage('token');
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
      'X-Taxi-Service': service_id
    });

    let penalty = null;
    if (tripCloseReason.penalty_value != 0 && tripCloseReason.penalty_value != '0%') {
      if (tripCloseReason.penalty_value.indexOf('+') == 0) {
        penalty = tripCloseReason.penalty_value;
      } else {
        penalty = '+' + tripCloseReason.penalty_value;
      }
    }

    const postData = {
      id: tripCloseReason.id,
      display_name: tripCloseReason.display_name,
      loc_display_name: tripCloseReason.loc_display_name,
      penalty_value: penalty,
      should_penalty: this.cleanNumber(tripCloseReason.penalty_value) ? 1 : 0
    };

    return this.http.put(this.reasonsUrl + '?service_id=' + service_id, JSON.stringify(postData), {
      headers: headers
    });
  }

  cleanNumber(stringToNumber) {
    if (stringToNumber.substr(-1) == '%') {
      return Number(stringToNumber.substr(0, stringToNumber.length - 1));
    } else {
      return Number(stringToNumber);
    }
  }

  removeReason(key, service_id): Observable<any> {
    let token = this.auth.getLocalStorage('token');
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
      'X-Taxi-Service': service_id
    });

    return this.http.delete(this.reasonsUrl + '?service=' + service_id + '&id=' + key, {
      headers: headers
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/service-conf.service.ts